import { reloadDocument } from "@src/utils/reload-document";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { NavigateOptions, useNavigate } from "react-router-dom";

import { forgetLastOrganization } from "./use-clear-on-organization-change";
import { useClearSessionMessages } from "./use-clear-session-messages";

export function useEndSession() {
  const queryClient = useQueryClient();
  const clearSessionMessages = useClearSessionMessages();
  const navigate = useNavigate();

  return useCallback(
    async (destination: string, options?: NavigateOptions) => {
      queryClient.clear();
      clearSessionMessages();
      forgetLastOrganization();
      await navigate(destination, options);
      reloadDocument();
    },
    [queryClient, clearSessionMessages, navigate],
  );
}
